export default "__VITE_ASSET__Bwm717MH__"